// extracted by mini-css-extract-plugin
export default {"image":"S0-z","loaded":"T0-z"};